import { QuestionType } from "@cirrus-author/questions/types"

export const isV2Question = (questionType) => {
  return (
    questionType === QuestionType.vpl ||
    questionType === QuestionType.multipleChoice ||
    questionType === QuestionType.multipleResponse ||
    questionType === QuestionType.eitherOr ||
    questionType === QuestionType.numeric ||
    questionType === QuestionType.extendedMultipleChoice ||
    questionType === QuestionType.ciPuzzle ||
    questionType === QuestionType.financialStatement ||
    questionType === QuestionType.section ||
    questionType === QuestionType.fileResponse ||
    questionType === QuestionType.essay ||
    questionType === QuestionType.shortAnswer ||
    questionType === QuestionType.assessmentPage
  )
}
